/* Size dropdown for products with both in-stock and made-to-order sizes
   (snippets/product-variant-options-clothing.liquid). The options are the
   theme's own size radio inputs, so this only opens and closes the list and
   mirrors the chosen size into the toggle. */
if (!customElements.get('size-dropdown')) {
  customElements.define(
    'size-dropdown',
    class SizeDropdown extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-size-dd-toggle]');
        this.valueLabel = this.querySelector('[data-size-dd-value]');
        this.panel = this.querySelector('.showvariant');
        if (!this.toggle || !this.panel) return;

        this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen));

        this.panel.addEventListener('change', (event) => {
          this.showError(false);
          this.showSelection(event.target);
        });

        // A pointer click on a row picks it and closes the list. Arrow keys
        // also move the selection (native radio behaviour) but report
        // detail 0, so keyboard users can browse with the list still open.
        this.panel.addEventListener('click', (event) => {
          if (!event.target.closest('label') || event.detail === 0) return;
          setTimeout(() => this.setOpen(false), 0);
        });

        this.addEventListener('keydown', (event) => {
          if (!this.isOpen) return;
          if (event.key === 'Escape' || (event.key === 'Enter' && event.target !== this.toggle)) {
            event.preventDefault();
            this.setOpen(false);
            this.toggle.focus();
          }
        });

        this.onOutsideClick = (event) => {
          if (this.isOpen && !this.contains(event.target)) this.setOpen(false);
        };
        document.addEventListener('click', this.onOutsideClick);

        // Add to Bag with no size chosen used to add the first size silently
        // (the form's id input is pre-filled with it). Stop that click, open
        // the list and show the "Please select a size" message instead.
        this.errorMessage = this.querySelector('.size-error-message2');
        this.onAddToCartClick = (event) => {
          const button = event.target.closest && event.target.closest('[data-add-to-cart]');
          if (!button || this.panel.querySelector('input[type="radio"]:checked')) return;
          const section = this.closest('.shopify-section');
          if (section && !section.contains(button)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError(true);
          this.setOpen(true);
        };
        document.addEventListener('click', this.onAddToCartClick, true);

        // A one-size product has nothing to choose, so select it up front.
        const radios = this.panel.querySelectorAll('input[type="radio"]');
        if (radios.length === 1 && radios[0].dataset.sizeState !== 'soldout') radios[0].checked = true;

        this.showSelection(this.panel.querySelector('input:checked'));
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutsideClick);
        document.removeEventListener('click', this.onAddToCartClick, true);
      }

      showError(visible) {
        if (!this.errorMessage) return;
        this.errorMessage.style.display = visible ? 'block' : 'none';
        // The open list covers the message, so repeat it in the toggle.
        if (visible && this.valueLabel) this.valueLabel.textContent = this.errorMessage.textContent.trim();
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      setOpen(open) {
        this.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
        if (!open) return;
        const target = this.panel.querySelector('input:checked') || this.panel.querySelector('input[type="radio"]');
        if (target) target.focus({ preventScroll: true });
      }

      showSelection(input) {
        if (!input || !this.valueLabel) return;
        // Mixed-stock products carry a status per size; sold-out sizes always do.
        const status = input.dataset.sizeTitle;
        // "One Size" already says size; avoid "Size One Size".
        const size = /size/i.test(input.value) ? input.value : `Size ${input.value}`;
        this.valueLabel.textContent = status ? `${size} · ${status}` : size;
      }
    }
  );
}
